import { petGenderElements } from '@flows/configs/petHealthV2/steps/elements/petGender'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'

const pet_gender = (params: StepConfigParams) =>
  fragmentStep(petGenderElements(params), params, 'breed_type')

export default pet_gender
